module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "login-outer-container scroll-outer",
    class: _vm.containerClass
  }, [_c('div', {
    staticClass: "gutter-horizontal-IEonly login-inner-container content-translate",
    class: _vm.innerClass
  }, [(_vm.logInModal) ? _c('div', {
    staticClass: "pad-60"
  }, [_c('p', {
    staticClass: "content-translate text-center color-red",
    class: _vm.statusClass
  }, [_vm._v(_vm._s(_vm.status))]), _vm._v(" "), _c('h1', {
    staticClass: "upcase text-center"
  }, [_vm._v("sign in")]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "span-5-lg offset-3-lg margin-right-12-lg span-7-md offset-1-md margin-right-12-md span-14-sm offset-1-sm span-14-xs offset-1-xs"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.email),
      expression: "user.email"
    }],
    staticClass: "form-text-area text-area-small p ",
    attrs: {
      "type": "text",
      "placeholder": "email"
    },
    domProps: {
      "value": (_vm.user.email)
    },
    on: {
      "keydown": _vm.checkForEnter,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.user.email = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "span-5-lg span-7-md span-14-sm offset-1-sm span-14-xs offset-1-xs"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.password),
      expression: "user.password"
    }],
    staticClass: "form-text-area text-area-small p ",
    attrs: {
      "type": "password",
      "placeholder": "password"
    },
    domProps: {
      "value": (_vm.user.password)
    },
    on: {
      "keydown": _vm.checkForEnter,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.user.password = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "row  margin-top-24"
  }, [_c('div', {
    staticClass: "span-7-lg offset-3-lg span-11-md offset-1-md span-11-sm offset-1-sm span-11-xs offset-1-xs margin-right-12-lg margin-right-12-md hide-xs "
  }, [_c('p', {
    staticClass: "a",
    on: {
      "click": _vm.toggleModal
    }
  }, [_vm._v("Don't have an account? Sign Up")])]), _vm._v(" "), _c('div', {
    staticClass: "span-3-lg span-3-md span-3-sm span-14-xs offset-1-xs "
  }, [_c('nav-button', {
    attrs: {
      "type": "next",
      "customclass": "float-right call-to-action",
      "clickevent": _vm.logIn
    }
  }, [_vm._v("Login")])], 1), _vm._v(" "), _c('div', {
    staticClass: "span-14-xs offset-1-xs show-xs"
  }, [_c('p', {
    staticClass: "a text-center",
    on: {
      "click": _vm.toggleModal
    }
  }, [_vm._v("Don't have an account? Sign Up")])])]), _vm._v(" "), _vm._m(0)]) : _vm._e(), _vm._v(" "), (_vm.signUpModal) ? _c('div', {
    staticClass: "pad-60"
  }, [_c('p', {
    staticClass: "content-translate text-center color-red",
    class: _vm.statusClass
  }, [_vm._v(_vm._s(_vm.status))]), _vm._v(" "), _c('h1', {
    staticClass: "upcase text-center"
  }, [_vm._v("Sign Up")]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "span-5-lg offset-3-lg margin-right-12-lg span-7-md offset-1-md margin-right-12-md span-14-sm offset-1-sm span-14-xs offset-1-xs"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newUser.firstName),
      expression: "newUser.firstName"
    }],
    staticClass: "form-text-area text-area-small p ",
    attrs: {
      "type": "text",
      "placeholder": "first name"
    },
    domProps: {
      "value": (_vm.newUser.firstName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.newUser.firstName = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "span-5-lg span-7-md span-14-sm offset-1-sm span-14-xs offset-1-xs"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newUser.lastName),
      expression: "newUser.lastName"
    }],
    staticClass: "form-text-area text-area-small p ",
    attrs: {
      "type": "text",
      "placeholder": "last name"
    },
    domProps: {
      "value": (_vm.newUser.lastName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.newUser.lastName = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "span-5-lg offset-3-lg margin-right-12-lg span-7-md offset-1-md margin-right-12-md span-14-sm offset-1-sm span-14-xs offset-1-xs"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newUser.email),
      expression: "newUser.email"
    }],
    staticClass: "form-text-area text-area-small p ",
    attrs: {
      "type": "email",
      "placeholder": "email"
    },
    domProps: {
      "value": (_vm.newUser.email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.newUser.email = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "span-5-lg offset-3-lg margin-right-12-lg span-7-md offset-1-md margin-right-12-md span-14-sm offset-1-sm span-14-xs offset-1-xs"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newUser.password),
      expression: "newUser.password"
    }],
    staticClass: "form-text-area text-area-small p ",
    attrs: {
      "type": "password",
      "placeholder": "password"
    },
    domProps: {
      "value": (_vm.newUser.password)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.newUser.password = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "span-5-lg span-7-md span-14-sm offset-1-sm span-14-xs offset-1-xs"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.confirmPassword),
      expression: "confirmPassword"
    }],
    staticClass: "form-text-area text-area-small p ",
    attrs: {
      "type": "password",
      "placeholder": "confirm password"
    },
    domProps: {
      "value": (_vm.confirmPassword)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.confirmPassword = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "row margin-top-24"
  }, [_c('div', {
    staticClass: "span-7-lg offset-3-lg span-11-md offset-1-md span-11-sm offset-1-sm span-11-xs offset-1-xs margin-right-12-lg margin-right-12-md hide-xs "
  }, [_c('p', {
    staticClass: "a",
    on: {
      "click": _vm.toggleModal
    }
  }, [_vm._v("Already have an account? Sign In")])]), _vm._v(" "), _c('div', {
    staticClass: "span-3-lg span-3-md span-3-sm span-14-xs offset-1-xs "
  }, [_c('nav-button', {
    attrs: {
      "type": "next",
      "customclass": "float-right call-to-action",
      "clickevent": _vm.register
    }
  }, [_vm._v("Submit")])], 1), _vm._v(" "), _c('div', {
    staticClass: "span-14-xs offset-1-xs show-xs"
  }, [_c('p', {
    staticClass: "a text-center",
    on: {
      "click": _vm.toggleModal
    }
  }, [_vm._v("Already have an account? Sign In")])])])]) : _vm._e(), _vm._v(" "), (_vm.continueCondition) ? _c('div', {
    staticClass: "pad-60"
  }, [_c('h1', {
    staticClass: "upcase text-center"
  }, [_vm._v(_vm._s(_vm.status) + "!")]), _vm._v(" "), (_vm.showContinueControls) ? _c('div', {
    staticClass: "row margin-top-24"
  }, [_c('div', {
    staticClass: "span-7-lg offset-3-lg span-11-md offset-1-md span-11-sm offset-1-sm span-11-xs offset-1-xs margin-right-12-lg margin-right-12-md hide-xs "
  }, [_c('p', {
    staticClass: "a",
    on: {
      "click": _vm.logOut
    }
  }, [_vm._v("Not you? Switch user")])]), _vm._v(" "), _c('div', {
    staticClass: "span-3-lg span-3-md span-3-sm span-14-xs offset-1-xs"
  }, [_c('nav-button', {
    attrs: {
      "type": "next",
      "customclass": "float-right call-to-action",
      "clickevent": _vm.loginSuccess
    }
  }, [_vm._v("Resume")])], 1), _vm._v(" "), _c('div', {
    staticClass: "span-14-xs offset-1-xs show-xs"
  }, [_c('p', {
    staticClass: "a text-center",
    on: {
      "click": _vm.logOut
    }
  }, [_vm._v("Not you? Switch user")])])]) : _vm._e()]) : _vm._e()])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "max-small"
  }, [_c('p', {
    staticClass: "text-center "
  }, [_c('em', [_c('strong', [_vm._v("Please make note of your login and password information.")]), _vm._v(" If these are misplaced, you will need to create a new login by notifying us at "), _c('a', {
    attrs: {
      "href": "mailto:kcoleman@futureswithoutviolence.org"
    }
  }, [_vm._v("kcoleman@futureswithoutviolence.org")]), _vm._v(" and restarting the module from the beginning.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-cc86951a"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/organisms/login.vue
// module id = 665
// module chunks = 1